import { Component } from '@angular/core';
import { CatalogService } from '../../services/catalog.service';
import { WindowService } from '../../services/window.service';
import { slideToLeftTransition} from '../../animations'

@Component({
  template: `
    <div class="body-wrapper ">
    <router-outlet>
    </router-outlet>
    </div>
    `,
    animations: [slideToLeftTransition]
})

export class DigitalOrderSheetComponent {
  
  constructor() { }


  // change the animation state
  getState(outlet) {
    return outlet.activatedRouteData.state;
  }
}
